import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { confirmAlert } from 'react-confirm-alert'
import { withRouter } from '../../components/funcs/BASES/withRouter'
import endPoints from '../../components/Consts/endPoints.json'
import { getTranslatation } from '../../locales/translate'

import { FaSave, FaFolder, FaShapes } from 'react-icons/fa'
import { FormLayout, MainLayout } from '../../components/features/Layouts'
import { InputOne } from '../../components/lib/input'
import { SelectOne } from '../../components/lib/select'
import { GridBlock } from '../../components/lib/grid'
import Grid from '@material-ui/core/Grid'
import UploadOne from '../../components/lib/upload/UploadOne'


import { Exercises, Ekipmanlar } from '../../components/features/Workout'

import * as AntrenmanActions from '../../redux/actions/Antrenman'
import * as AlldetailsActions from '../../redux/actions/Alldetails'

class WorkoutForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      onProcess: false,
      activeSection: 'form', // files

      antrenman_id: '',

      antrenmanName: '',
      manualDuration: '', // opsiyonel: bos ise mobilde hesaplanan sure gosterilir
      manualCalory: '', // opsiyonel: bos ise mobilde hesaplanan toplam kalori gosterilir
      egzersizler: [],
      ekipmanlar: [],
      
      translated: {
        en: {
          antrenmanName: ''
        },
        tr: {
          antrenmanName: ''
        }
      }
    }
    this.releatedRoutes = endPoints.find(aa => aa.name == 'Workout')?.routes
    this.ref_fileArea = React.createRef()
  }

  componentDidMount() {
    this.props.actions.GetAllDetails(null, () => { }, () => { }, () => { }, () => { })
    try {
      var id = this.props.router.location.state.id
      this.setState({ antrenman_id: id }, () => {
        this.props.actions.GetOne(
          this.state.antrenman_id,
          () => {
            this.setState({ onProcess: true })
          },
          () => {
            setTimeout(
              function () {
                this.setState({ onProcess: false })
              }.bind(this),
              500
            )
          },
          data => {
            this.setPageForGETID(data)
          },
          () => { }
        )
      })
    } catch (err) { }
  }

  setPageForGETID = data => {
    this.setState({
      antrenmanName: data?.antrenmanName,
      manualDuration: (data?.manualDuration != null) ? String(data.manualDuration) : '',
      manualCalory: (data?.manualCalory != null) ? String(data.manualCalory) : '',
      egzersizler: data?.egzersizler,
      ekipmanlar: data?.ekipmanlar,
      translated: data?.translated || {
        en: { antrenmanName: '' },
        tr: { antrenmanName: '' }
      }
    },
      () => {
        this.ref_fileArea.current.state.files = data?.andrenmanImage != null ? data?.andrenmanImage : []
      })
  }

  submit = () => {
    var id = this.props.router?.location?.state?.id
    if (id == null || id == '') {
      // CREATE
      this.props.actions.Create(
        this.state,
        () => {
          this.setState({ onProcess: true })
        },
        () => {
          setTimeout(() => {
            this.setState({ onProcess: false })
          }, 500)
        },
        () => {
          this.props.router.navigate(this.releatedRoutes.get)
        },
        () => { }
      )
    } else {
      // UPDATE
      this.props.actions.Update(
        this.state,
        () => {
          this.setState({ onProcess: true })
        },
        () => {
          setTimeout(() => {
            this.setState({ onProcess: false })
          }, 500)
        },
        () => {
          this.props.router.navigate(this.releatedRoutes.get)
        },
        () => { }
      )
    }
  }

  setVal = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  render() {
    return (
      <FormLayout
        naviIcon={<FaShapes size={30} color={'white'} />}
        recordIcon={<FaSave size={30} color={'white'} />}
        recordAction={this.submit}
        filesIcon={
          (this.state.antrenman_id != null && this.state.antrenman_id != '') &&
          <div onClick={() => { this.setState({ activeSection: this.state.activeSection == 'form' ? 'files' : 'form' }) }} >
            <FaFolder size={30} color={'white'} />
          </div>}
        activeBack={() => {
          this.props.router.navigate(this.releatedRoutes?.get)
        }}
        loading={this.state.onProcess}
      >

        <GridBlock
          style={{
            display: this.state.activeSection == 'files' ? 'block' : 'none'
          }} container={true} xs={12} sm={12} lg={12}>
          <UploadOne
            ref={this.ref_fileArea}
            innerRef={this.ref_fileArea}
            cascadeID={this.state.antrenman_id}
            showDropAreaWhenFull={true}
            formID={5} // egzersiz image 1 adet
            allowedLength={1}
            xs={12}
            sm={12}
            lg={12}
            _xs={12}
            _sm={12}
            _lg={12}
            _mainContainer
            acceptFiles={'image/jpeg, image/png, image/jpg'}
            dropLabel={
              <div>
                Antrenman resmi yükleyiniz <br /> en fazla 1 Adet{' '}
              </div>
            }
          />
        </GridBlock>


        <GridBlock
          style={{
            display: this.state.activeSection == 'form' ? 'block' : 'none'
          }} container={true} xs={12} sm={12} lg={12}>
          <GridBlock title={endPoints.find(aa => aa.name == 'Workout')?.menutext} container={true} xs={12} sm={12} lg={12}>
            <InputOne
              color={'success'}
              variant='filled'
              margin='none'
              required
              fullWidth
              xs={12}
              sm={12}
              lg={12}
              id='antrenmanName'
              label={getTranslatation('antrenmanName', 'EXERCISE')}
              name='antrenmanName'
              value={this.state.antrenmanName}
              onChange={this.setVal}
              // error={this.state.mailOrPhone_ERROR.length > 0}
              helperText={getTranslatation('antrenmanNameHelper', 'EXERCISE')}
            />

            <InputOne
              type={'number'}
              color={'success'}
              variant='filled'
              margin='none'
              fullWidth
              xs={12}
              sm={6}
              lg={6}
              id='manualDuration'
              label='Süre (dakika) — opsiyonel'
              name='manualDuration'
              value={this.state.manualDuration}
              onChange={this.setVal}
              helperText='Boş bırakılırsa antrenman süresi egzersizlerden otomatik hesaplanır. Bir değer girilirse kartta bu süre gösterilir.'
            />

            <InputOne
              type={'number'}
              color={'success'}
              variant='filled'
              margin='none'
              fullWidth
              xs={12}
              sm={6}
              lg={6}
              id='manualCalory'
              label='Kalori (kcal) — opsiyonel'
              name='manualCalory'
              value={this.state.manualCalory}
              onChange={this.setVal}
              helperText='Boş bırakılırsa antrenman kalorisi egzersizlerden otomatik hesaplanır. Bir değer girilirse kartta bu kalori gösterilir.'
            />

            <GridBlock title='Bağlı egzersizler' container={true} xs={12} sm={12} lg={8}>
              <Exercises egzersizler={this.state.egzersizler} fakeThis={this} />
            </GridBlock>

            <GridBlock title='Belirlenmiş ekipmanlar' container={true} xs={12} sm={12} lg={4}>
              <Ekipmanlar ekipmanlar={this.state.ekipmanlar} fakeThis={this} />
            </GridBlock>

            <GridBlock
              title='Çeviriler (Translations)'
              container={true}
              xs={12}
              sm={12}
              lg={12}
            >
              <GridBlock
                title='İngilizce (EN)'
                container={true}
                xs={12}
                sm={12}
                lg={6}
              >
                <InputOne
                  color={'success'}
                  variant='filled'
                  margin='none'
                  fullWidth
                  xs={12}
                  sm={12}
                  lg={12}
                  id='translated_en_antrenmanName'
                  label='Workout Name (EN)'
                  name='translated_en_antrenmanName'
                  value={this.state.translated.en.antrenmanName}
                  onChange={(e) => {
                    this.setState({
                      translated: {
                        ...this.state.translated,
                        en: {
                          ...this.state.translated.en,
                          antrenmanName: e.target.value
                        }
                      }
                    })
                  }}
                  helperText='İngilizce antrenman adı'
                />
              </GridBlock>

              <GridBlock
                title='Türkçe (TR)'
                container={true}
                xs={12}
                sm={12}
                lg={6}
              >
                <InputOne
                  color={'success'}
                  variant='filled'
                  margin='none'
                  fullWidth
                  xs={12}
                  sm={12}
                  lg={12}
                  id='translated_tr_antrenmanName'
                  label='Antrenman Adı (TR)'
                  name='translated_tr_antrenmanName'
                  value={this.state.translated.tr.antrenmanName}
                  onChange={(e) => {
                    this.setState({
                      translated: {
                        ...this.state.translated,
                        tr: {
                          ...this.state.translated.tr,
                          antrenmanName: e.target.value
                        }
                      }
                    })
                  }}
                  helperText='Türkçe antrenman adı'
                />
              </GridBlock>
            </GridBlock>

          </GridBlock>
        </GridBlock>


      </FormLayout>
    )
  }
}

//connect componenet with redux store
function mapStateToProps(state) {
  return {
    AlldetailsReducers: state.AlldetailsReducers
  }
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      GetOne: bindActionCreators(AntrenmanActions.GetOne, dispatch),
      Create: bindActionCreators(AntrenmanActions.Create, dispatch),
      Update: bindActionCreators(AntrenmanActions.Update, dispatch),

      GetAllDetails: bindActionCreators(AlldetailsActions.GetAllDetails, dispatch)

      // Delete: bindActionCreators(UsersActions.Delete, dispatch)
    }
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(WorkoutForm)
)
